import { useIsFocused } from "@react-navigation/native";
import React, { useEffect, useState } from "react";
import {
  FlatList,
  View,
  StyleSheet,
  TouchableOpacity,
  Alert,
  Dimensions,
} from "react-native";
import questions from "../api/questions";
import storage from "../auth/storage";
import ActivityIndicator from "../components/ActivityIndicator";
import AppText from "../components/AppText";
import CommonFooter from "../components/CommonFooter";
import { StdAlert } from "../components/CustomAlert";
import Screen from "../components/Screen";
import colors from "../config/colors";
import useApi from "../hooks/useApi";
import { convertDate } from "../util/convertDate";

function Submissions({ navigation, route }) {
  const lastTwoApi = useApi(questions.getLastTwo);
  const [submissions, setSubmissions] = useState();
  const [name, setName] = useState("");
  const [location, setLocation] = useState("");
  const isFocused = useIsFocused();

  useEffect(() => {
    async function getLast2() {
      const getName = await storage.getName();
      const getLocation = await storage.getLocation();
      console.log(getName, getLocation, "jfskl");
      setName(getName);
      setLocation(getLocation);
      const token = await storage.getToken();
      // console.log(token, 'lfs');
      const result = await lastTwoApi.request(token);
      console.log("kls", result, "jkl");
      if (result.data?.submission) {
        setSubmissions(result.data.submission);
        return;
      }
      if (result.data?.response?.code !== "200") {
        console.log(isFocused, "jk;");
        return StdAlert(
          "",
          result.data?.response.message || "Some error occured."
        );
        // return Alert.alert(
        //   "",
        //   result.data?.response.message || "Some error occured."
        // );
      }
    }
    if (isFocused) getLast2();
    return () => {
      console.log("This will be logged on unmount");
    };
  }, [isFocused]);

  const showDetail = (item) => {
    navigation.navigate("Final", { item, lastTwo: true });
  };
  return (
    <Screen style={styles.container}>
      <View style={styles.nameView}>
        <AppText
          color="transparent"
          textColor="white"
          style={{ fontSize: 22, fontWeight: "700" }}
        >
          {name || ""}
        </AppText>
        <AppText color="transparent" textColor="white">
          {location || ""}
        </AppText>
      </View>
      <ActivityIndicator visible={lastTwoApi.loading} />
      {submissions?.length > 0 && (
        <FlatList
          style={{
            // marginHorizontal: 10,
            // marginTop: 10,
            // marginBottom: 70,
            backgroundColor: colors.white,
          }}
          // contentContainerStyle={{
          //   alignItems: 'center',
          //   width: '70%',
          // }}
          data={submissions}
          keyExtractor={(item) => {
            // console.log(
            //   reportData.options[item][
            //     Object.keys(reportData.options[item])[0]
            //   ],
            //   "kskl"
            // );
            return item.record_id.toString();
          }}
          ListHeaderComponent={
            <AppText
              style={{
                fontSize: 22,
                textAlign: "center",
                margin: 20,
                fontWeight: "700",
                width: "40%",
                alignSelf: "center",
              }}
            >
              Previous Score Reports
            </AppText>
          }
          renderItem={({ item, index }) => (
            <TouchableOpacity
              style={[
                styles.recommendView,
                {
                  backgroundColor: index === 0 ? colors.yellow : colors.primary,
                },
              ]}
              onPress={() => showDetail(item)}
            >
              <AppText
                color={"transparent"}
                textColor={index === 0 ? "black" : "white"}
                style={styles.recommendTitle}
              >
                {"Score Report"}
              </AppText>
              <AppText
                color={"transparent"}
                textColor={index === 0 ? "black" : "white"}
                style={styles.recommendDate}
              >
                {convertDate(item.date_created.split(" ")[0])}
              </AppText>
              <AppText
                color={"transparent"}
                textColor={index === 0 ? "black" : "white"}
                style={styles.recommendPoints}
              >
                {item.submission_total_score >= 100
                  ? 100
                  : item.submission_total_score}
              </AppText>
            </TouchableOpacity>
          )}
        />
      )}
      {!submissions ||
        (submissions.length <= 0 && (
          <AppText color="transparent" style={{ alignSelf: "center" }}>
            No Submissions
          </AppText>
        ))}
      <View style={{ position: "absolute", bottom: 0 }}>
        <CommonFooter navigation={navigation} />
      </View>
    </Screen>
  );
}

const styles = StyleSheet.create({
  container: {
    // flex: 1,
    backgroundColor: colors.newGray,
    // alignItems: "center",
    // justifyContent: "center",
    // alignContent: "center",
  },
  nameView: {
    alignItems: "center",
    justifyContent: "center",
    height: 80,
    backgroundColor: colors.lightGreen,
  },
  recommendView: {
    flex: 1,
    flexDirection: "column",
    borderRadius: 6,
    width: "85%",
    minHeight: 100,
    marginVertical: 10,
    justifyContent: "center",
    alignItems: "flex-start",
    alignSelf: "center",
    // justifyContent: "space-between",
  },
  recommendTitle: {
    marginLeft: 10,
    marginTop: 10,
    fontWeight: "700",
    textAlign: "center",
    marginRight: 20,
  },
  recommendDate: {
    marginLeft: 10,
    textAlign: "center",
    marginVertical: 10,
    fontSize: 14,
    marginRight: 20,
    // alignSelf: 'flex-end',
  },
  recommendPoints: {
    right: 10,
    textAlign: "center",
    // marginVertical: 26,
    fontSize: 60,
    fontWeight: "800",
    position: "absolute",
    alignSelf: "center",
  },
});

export default Submissions;
